import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { GroupAdminAddFormValues } from '../../../arc/features/groups/admin/group-admin-add-form-model';
import { OfficerAddFormValues } from '../../../arc/features/institution-officers/officer-add-form-model';
import { DependentFormValues } from '../../features/dependents/dependent-form-models';
import { MaritalStatusFormValues } from '../../features/marital-status/marital-form-models';
import { EmailFields } from '../../models/form-models';

interface ContentProps {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | EmailFields;
    labelSetting: LabelSettingProps;
}

export function EmailsContentDisplay(props: ContentProps) {
    const { values, labelSetting } = props;

    if (!values.office_email_address && !values.personal_email_address) return null;

    return (
        <>
            {values.office_email_address && <LabelAndValue label={labelSetting.businessEmailLabel} value={values.office_email_address} />}
            {values.personal_email_address && <LabelAndValue label={labelSetting.personalEmailLabel} value={values.personal_email_address} />}
        </>
    );
}

interface Props {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | EmailFields;
    labelSetting: LabelSettingProps;
}
export function EmailsDisplay(props: Props) {
    const { values, labelSetting } = props;

    if (!values.office_email_address && !values.personal_email_address) return null;

    return (
        <>
            <ContentSpacer>
                <h3>{labelSetting.emailSectionTitle}</h3>
            </ContentSpacer>
            <EmailsContentDisplay
                labelSetting={labelSetting}
                values={values}
            />
        </>
    );
}